import React from 'react'
import ScrollUpButton from 'react-scroll-up-button'

const AboutPage = () => (
  <div className='about'>
    <ul className="breadcrumb">
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <a href="/" itemProp="url">
          <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
        </a>
      </li>
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <span itemProp="title"> <i className="fas fa-caret-right"></i> 当シェアハウスの魅力</span>
      </li>
    </ul>
    <div className='column'>
      <h3>ひつじ不動産のホームページに掲載して頂きました <i class="far fa-thumbs-up"></i></h3>
      <img src='https://www.hituji.jp/img/comret/kanagawa/sagamihara/share-house-living-in-a-penny-candy-store/017.jpg' alt='' />
      <div className='description'>
        <ul>
          <li>業界最大級のシェアハウス紹介サイトであります「<span class='textdecoration'><a href="https://www.hituji.jp/comret/info/kanagawa/sagamihara/share-house-living-in-a-penny-candy-store">ひつじ不動産</a></span>」に掲載して頂きました。</li>
          <li>お部屋の大きさ、収納スペースなど、審査基準が比較的に厳格で有名ですが、無事審査が通りました。</li>
          <li>サービス向上に日々取り組んで参りますので、よろしくお願い致します。</li>
        </ul>
      </div>
    </div>
    <div className='column'>
      <h3>駄菓子屋で接客してお小遣い稼ぎ <i class="far fa-thumbs-up"></i></h3>
      <img src='images/dagashi_shop.png' alt='' />
      <div className='description'>
        <ul>
          <li>リビングルーム隣の土間スペースが駄菓子屋になっています</li>
          <li><span class='textdecoration'>駄菓子屋で接客してお小遣い稼ぎ</span>が可能です</li>
          <li><a href='/shop'>子供が多い地域</a>ですので、<span class='textdecoration'>子供好きには最適</span></li>
          <li><a href='https://airregi.jp/payment/' target="_blank" rel="noopener">AirPay</a>を導入していますので、レジ対応や販売管理も簡単</li>
          <li>入居者が在宅＝開店時間 のため、<span class='textdecoration'>様々なライフワークに適合</span></li>
          <li>ご希望により、商品選定・ネット販売・ライブ配信などの新しい試みに挑戦できます</li>
        </ul>
      </div>
    </div>
    <div className='column'>
      <h3>一般的な賃貸アパートと比べてとても安価 <i class="far fa-thumbs-up"></i></h3>
      <div className='description'>
      3ヶ月の賃貸契約で、同じ家賃で試算しますと、<br />
      当シェアハウスの方が<span class='textdecoration'>25万円程度安価</span>となります！更新費用も不要です！<br />
      <br />
      </div>
      <table>
        <thead>
          <tr>
            <th scope='col'>項目</th>
            <th scope='col'>当シェアハウス</th>
            <th scope='col'>一般的な賃貸アパート</th>
            <th scope='col'>備考</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className='name'>家賃</td>
            <td className='content'>4.5万円 x 3ヶ月分</td>
            <td className='content'>4.5万円 x 3ヶ月分</td>
            <td className='note'></td>
          </tr>
          <tr>
            <td className='name'>管理費（共益費）</td>
            <td className='content'>12,000円 x 3ヶ月分</td>
            <td className='content'>10,000円 x 3ヶ月分</td>
            <td className='note'>当シェアハウス では、水道光熱費、無線インターネット利用料、駄菓子屋損失（廃棄、雑損、窃盗、破損等）、修繕積立金が含まれます</td>
          </tr>          
          <tr>
            <td className='name'>水道光熱費</td>
            <td className='content'>0</td>
            <td className='content'>(1万円～1万5千円) x 3ヶ月分</td>
            <td className='note'>当シェアハウス では、管理費（共益費）に含まれます</td>
          </tr>
          <tr>
            <td className='name'>無線インターネット利用料</td>
            <td className='content'>0</td>
            <td className='content'>6,000円 x 3ヶ月分</td>
            <td className='note'>当シェアハウス では、共益費に含まれます</td>
          </tr>
          <tr>
            <td className='name'>敷金</td>
            <td className='content'>無し</td>
            <td className='content'>家賃1ヶ月分</td>
            <td className='note'>退去時に原状回復するための費用。補填後の残金は返金される</td>
          </tr>          
          <tr>
            <td className='name'>礼金</td>
            <td className='content'>無し</td>
            <td className='content'>家賃1ヶ月分</td>
            <td className='note'>賃貸オーナーへの礼金のため、返金されない</td>
          </tr>
          <tr>
            <td className='name'>仲介手数料</td>
            <td className='content'>無し</td>
            <td className='content'>家賃1ヶ月分</td>
            <td className='note'>仲介業者への支払い。宅建業法では家賃の半分が原則だが、一般的には１ヶ月分が多い</td>
          </tr>
          <tr>
            <td className='name'>火災保険料</td>
            <td className='content'>任意加入</td>
            <td className='content'>1万円〜</td>
            <td className='note'>当シェアハウス では、オーナー向けの火災保険に加入しています。借主による家財保険、借家人賠償責任保険、個人賠償責任補償特約は任意加入となっています。料金は保証期間・保証内容によって、様々です</td>
          </tr>
          <tr>
            <td className='name'>鍵交換費</td>
            <td className='content'>無料</td>
            <td className='content'>1.5万円</td>
            <td className='note'>『国土交通省のガイドラン』では家主負担が原則だが、借主が負担するケースが多い</td>
          </tr>
          <tr>
            <td className='name'>保証金</td>
            <td className='content'>無し</td>
            <td className='content'>家賃0.5ヶ月分</td>
            <td className='note'>日本賃貸住宅保証機構株式会社などの保証会社への費用。保証人がいても加入を義務付ける事も</td>
          </tr>
          <tr>
            <td className='name'>書類作成費用</td>
            <td className='content'>無し</td>
            <td className='content'>1万円程度</td>
            <td className='note'></td>
          </tr>
          <tr>
            <td className='name'>家電・家具・生活必需品</td>
            <td className='content'>1万円 ※1</td>
            <td className='content'>3万～10万</td>
            <td className='note'>
              <span class='textdecoration-bold'>当シェアハウスの専用設備：</span><br />
              エアコン、WiFi、1畳分の収納スペース、ベッド、ドレッサー兼作業机<br />
              <br />
              <span class='textdecoration-bold'>当シェアハウスの共用設備：</span><br />
              冷蔵庫、電子レンジ、食洗機、炊飯器、IHコンロ、洗濯機、掃除機、湯沸かし器、43型録画機能付きテレビ、キッチンボード、カウチソファ、温水洗浄便座２機、浴室、シャワー室、中庭、屋上テラス、駄菓子屋、IH対応鍋、IH対応フライパン、生活用品（トイレットペーパー）<br />
              <br />
              ※1 掛け布団、敷布団、ドライヤー、食器など
            </td>
          </tr>
          <tr>
            <td className='name'>
              <span class='textdecoration-bold'>合計</span>
            </td>
            <td className='content'>
              <span class='textdecoration-bold'>18万1,000円</span><br />
            </td>
            <td className='content'>
              <span class='textdecoration-bold'>43万5,500円～</span>
            </td>
            <td className='note'>キャンペーンを適用して1ヶ月のお家賃分マイナス</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className='column'>
      <h3>入居者用の自転車でサイクリングを楽しめます <i class="far fa-thumbs-up"></i></h3>
      <div className='description'>
        スーパー、コンビニ、駅、図書館、市役所、市営の運動施設（ジム、プール兼スケート場、テニス場、卓球、体育館）などへの<span class='textdecoration'>アクセスに便利！</span>
        <ul>
          <li><span class='emphatextdecorationsis'>入居者一人一人に自転車を１台用意</span></li>
          <li><span class='textdecoration'>美容と健康のための快適な運動環境</span></li>
          <li>関東では少ないスケート場</li>
          <li>詳しくは、<a href='/access'>アクセスページ</a>をご覧下さい</li>    
        </ul>
      </div>
      <img src='images/skating.png' alt='銀河アリーナスケート場の入り口' />
    </div>
    <div className='column'>
      <h3>家庭菜園、DIY、パソコン体験 <i class="far fa-thumbs-up"></i></h3>
      <div className='description'>
        当シェアハウスは発展途上です。入居者様のご要望を伺いながら、<br />
        主に<span class='textdecoration'>DIYでより良い住まいに改善</span>させていく予定です<br />
        <br />
        特に力をいれたい箇所は以下の通りです
        <ul>
          <li>駄菓子屋の売り場スペース</li>
          <li>中庭のアンティーク空間の装飾品や家庭菜園</li>
          <li>屋上テラス</li>
          <li>リビングなどの共有スペース</li>
        </ul>
        オーナーがソフトウェアエンジニアですので、希望者には<span class='textdecoration'>パソコン教室も企画</span>しています
      </div>
    </div>
    <div className='column'>
      <h3>まずはお気軽にお問い合わせください <i class="far fa-thumbs-up"></i></h3>
      <div className='description'>
      <span class='textdecoration'>女性専用</span>、<span class='textdecoration'>外国籍可</span>、<span class='textdecoration'>保証人・収入証明書不要</span>、人間性を重視します<br />
      個人情報の提示も必要最低限になるように努めます<br />
        皆様からのご連絡を心からお待ち申し上げます
        <ul>
          <li>入居までの流れは、<a href='/flow'>こちら</a></li>
          <li>空き状況・間取り・家賃は、<a href='/detail'>こちら</a></li>
          <li>アクセス情報は、<a href='/access'>こちら</a></li>
          <li>物件の写真ギャラリーは、<a href='/photosRoom'>こちら</a></li>
          <li>よくあるご質問は、<a href='/faq'>こちら</a></li>
          <li><span class='textdecoration'>お問い合わせ・内覧のご予約</span>は、<a href='/contact'>こちら</a></li>
        </ul>
      </div>
    </div>
    <ScrollUpButton style={{width: 30, height: 30}} />
  </div>
)

export default AboutPage


// WEBPACK FOOTER //
// ./src/AboutPage.js